import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Collapse,
  Form,
  Input,
  Label,
  Button,
  FormFeedback,
  Modal,
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  Nav,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { getHagueCrawlInfoList } from "../../store/actions";
import PeriodBtn from "../../components/Filter/PeriodBtn";

function HagueCrawlInfo({ toggle, activeTab, isOpen, tabId }) {

  const dispatch = useDispatch();

  const { noticeStr, totalPage, hagueCrawlInfoList, hagueRemaining } = useSelector(state => ({
    noticeStr: state.admDataManagement.noticeStrHague,
    totalPage: state.admDataManagement.totalPageHague,
   hagueCrawlInfoList: state.admDataManagement.hagueCrawlInfoList,
   hagueRemaining: state.admDataManagement.hagueRemaining
  }))

  const filterValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      submitType: "view",

      perPage: 20,
      curPage: 1,
      datePeriod: "",
      fromDate: "",
      toDate: "",
      hagueDiscrepencyYn: "A"
    },

    onSubmit: (values) => {

      const filterParam = {
        limit: values["perPage"],
        curPage: values["curPage"],
        fromDate: values.fromDate?.replace(/-/g, "") ?? "",
        toDate: values.toDate?.replace(/-/g, "") ?? "",
        discrepencyYn: values['hagueDiscrepencyYn']
      };

      let submitType = values["submitType"];

      if (submitType === "view") {
        console.log(filterParam)
        dispatch(getHagueCrawlInfoList(filterParam));
      }
    }
  })

  const onPageChange = (curPage, perPage) => {
    filterValidation.setFieldValue("submitType", "view");

    if (curPage) {
      // setCurPageInput(curPage);
      filterValidation.setFieldValue("curPage", curPage);
    } else {
      // setCurPageInput(1);
      filterValidation.setFieldValue("curPage", 1);
    }

    if (perPage) {
      filterValidation.setFieldValue("perPage", perPage);
    }

    filterValidation.handleSubmit(filterValidation.values);
  }

  return (
    <TabPane style={activeTab === tabId ? {display: "block"} : {display: "none"}} tabId={tabId}>
      <Row>
        <Col lg={12}>
          <Card>
            <Link onClick={toggle} className="text-dark" to="#">
              <div className="p-4">
                <Media className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-3">
                    <i className="uil uil-file-copy-alt text-primary h2"></i>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <h5 className="font-size-16 mb-1">Data Management</h5>
                  </div>
                  <i className="uil uil-filter font-size-24 text-muted"></i>
                </Media>
              </div>
            </Link>
            <Collapse isOpen={isOpen}>
              <div className="p-4 border-top">
                <Row>
                  <label htmlFor="inscribedDate" className="col-md-1 col-form-label" style={{ paddingTop: '0px' }}>
                    Date
                  </label>
                  <div className="col-md-11">
                    <PeriodBtn
                      formik={filterValidation}
                    />
                  </div>
                </Row>
                <Row className="mb-3">
                  <label
                    className="col-md-3 col-form-label"
                  >
                    Data
                  </label>
                  <div
                    className="col-md-2 form-check"
                    style={{ paddingLeft: "2em", paddingTop: '8px' }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hagueDiscrepencyYn"
                      id="hagueDiscrepencyY"
                      value="Y"
                      onChange={filterValidation.handleChange}
                      checked={
                        filterValidation.values.hagueDiscrepencyYn === "Y"
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="hagueDiscrepencyY"
                    >
                      Discrepencies
                    </label>
                  </div>
                  <div
                    className="col-md-2 form-check"
                    style={{ paddingLeft: "2em", paddingTop: '8px' }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hagueDiscrepencyYn"
                      id="hagueDiscrepencyA"
                      value="A"
                      onChange={filterValidation.handleChange}
                      checked={
                        filterValidation.values.hagueDiscrepencyYn === 'A'
                      }
                    />
                    <label className="form-check-label" htmlFor="hagueDiscrepencyA">
                      All
                    </label>
                  </div>
                </Row>
                <Row >
                  <Col md={2}>&nbsp;</Col>
                  <Col md={3}>&nbsp;</Col>
                  <Col md={3}>
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light col-md-5"
                      onClick={() => {
                        filterValidation.setFieldValue("curPage", 1);
                        filterValidation.setFieldValue("submitType", "view");
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      Search
                    </button>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </Card>
        </Col>
      </Row>
      {
        noticeStr &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="text-muted mb-0">
                  <p style={{ whiteSpace: "pre" }}>
                    {noticeStr}
                  </p>
                </CardTitle>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
      {
        Array.isArray(hagueCrawlInfoList) && hagueCrawlInfoList.length > 0 &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table mb-0" style={{width: "500px"}}>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>FTP (t)</th>
                        <th>FTP</th>
                        <th>HRU (t)</th>
                        <th>HRU</th>
                        <th>Remaining: {hagueRemaining}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                       hagueCrawlInfoList.map((info, index) => {
                          const diff = info.ftpCount - info.hruCount;
                          return (
                            <tr key={info.crawlDate} style={diff != 0 ? { backgroundColor: "rgb(245, 194, 191)" } : {}}>
                              <td>{`${info.crawlDate.substring(0, 4)}/${info.crawlDate.substring(4, 6)}/${info.crawlDate.substring(6, 8)}`}</td>
                              <td>{info.ftpTime || "-"}</td>
                              <td>{info.ftpCount || "-"}</td>
                              <td>{info.hruTime || "-"}</td>
                              <td>{info.hruCount || "-"}</td>
                              <td>&nbsp;</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex justify-content-between" style={{ marginTop: "20px" }}>
                  <span className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="perPage"
                    >
                      Entries per page
                    </label>
                    <div style={{ width: "100px" }}>
                      <select
                        className="form-select"
                        name="perPage"
                        onChange={e => { onPageChange(1, e.target.value); }}
                        value={filterValidation.values.perPage}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </span>
                  <span className="d-flex align-items-center gap-2">
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<<"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) - 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<"}
                      </Button>
                    </div>
                    Page{" "}
                    <strong>
                      {filterValidation.values.curPage} of {totalPage}
                    </strong>

                    <Input
                      type="number"
                      min={1}
                      style={{ width: 70 }}
                      max={totalPage}
                      name="curPage"
                      defaultValue={filterValidation.values.curPage}
                      value={filterValidation.values.curPage}
                      onChange={(e) => { 
                        const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                        // setCurPageInput(_curPage, totalPage)
                        filterValidation.setFieldValue("curPage", _curPage);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                          onPageChange(_curPage, filterValidation.values.perPage);
                        }
                      }}
                    />
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) + 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(totalPage, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">>"}
                      </Button>
                    </div>
                  </span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
    </TabPane>
  )
}

export default HagueCrawlInfo;